/*
 * Heaer Messages
 *
 * This contains all the text for the Heaer container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.Heaer';

export default defineMessages({
  welcomeText: {
    id: `${scope}.welcomeText`,
    defaultMessage: 'Welcome to Actively',
  },
  eventHome: {
    id: `${scope}.eventHome`,
    defaultMessage: 'Events',
  },
  eventTeamList: {
    id: `${scope}.eventTeamList`,
    defaultMessage: 'Team list',
  },
  eventVolunteerList: {
    id: `${scope}.eventVolunteerList`,
    defaultMessage: 'Volunteer list',
  },
  eventMemberList: {
    id: `${scope}.eventMemberList`,
    defaultMessage: 'Walker list',
  },
  eventSupporterList: {
    id: `${scope}.eventSupporterList`,
    defaultMessage: 'Supporter list',
  },
  eventVolunteerDetail: {
    id: `${scope}.eventVolunteerDetail`,
    defaultMessage: 'Volunteer detail',
  },
  memberDetail: {
    id: `${scope}.memberDetail`,
    defaultMessage: 'Member detail',
  },
  profile: {
    id: `${scope}.profile`,
    defaultMessage: 'Profile',
  },
  logout: {
    id: `${scope}.logout`,
    defaultMessage: 'Logout',
  },
  logoutWarn: {
    id: `${scope}.logoutWarn`,
    defaultMessage: 'Do you want to logout?',
  },
  manageUser: {
    id: `${scope}.manageUser`,
    defaultMessage: 'Manage users',
  },
  bib: {
    id: `${scope}.bib`,
    defaultMessage: 'BIB',
  },
  confirmed: {
    id: `${scope}.confirmed`,
    defaultMessage: 'Confirmed',
  },
  dropped: {
    id: `${scope}.dropped`,
    defaultMessage: 'Dropped',
  },
  postponed: {
    id: `${scope}.postponed`,
    defaultMessage: 'Postponed',
  },
  updateTeamStatusSuccess: {
    id: `${scope}.updateTeamStatusSuccess`,
    defaultMessage: 'Team status is updated successfully',
  },
  switchRoleToAdmin: {
    id: `${scope}.switchRoleToAdmin`,
    defaultMessage: 'Switch to admin',
  },
  switchRoleToOnboarder: {
    id: `${scope}.switchRoleToOnboarder`,
    defaultMessage: 'Switch to onboarder',
  },
  only_male_participants: {
    id: `${scope}.only_male_participants`,
    defaultMessage: 'Only male participants',
  },
  age_under_12: {
    id: `${scope}.age_under_12`,
    defaultMessage: 'Under 12 years old',
  },
  age_above_90: {
    id: `${scope}.age_above_90`,
    defaultMessage: 'Over 90 years old',
  },
  company_project_without_coupon: {
    id: `${scope}.company_project_without_coupon`,
    defaultMessage: 'Company project but without registration coupon',
  },
  participants_with_duplicate_email: {
    id: `${scope}.participants_with_duplicate_email`,
    defaultMessage: 'Duplicate email address',
  },
  max_team_size_goals_reached: {
    id: `${scope}.max_team_size_goals_reached`,
    defaultMessage: 'Team size reached',
  },
  notifications: {
    id: `${scope}.notifications`,
    defaultMessage: 'Notifications',
  },
  globalDashboard: {
    id: `${scope}.globalDashboard`,
    defaultMessage: 'Annual Dashboard',
  },
  roleSelectTitle: {
    id: `${scope}.roleSelectTitle`,
    defaultMessage: 'Select view mode',
  },
  roleSelectHint: {
    id: `${scope}.roleSelectHint`,
    defaultMessage: 'Choose how you want to view the application',
  },
  login: {
    id: `${scope}.login`,
    defaultMessage: 'Login',
  },
  forgotPassword: {
    id: `${scope}.forgotPassword`,
    defaultMessage: 'Forgot Password',
  },
  resetPassword: {
    id: `${scope}.resetPassword`,
    defaultMessage: 'Reset Password',
  },
  userProfile: {
    id: `${scope}.userProfile`,
    defaultMessage: 'User Profile',
  },
  adminDashboard: {
    id: `${scope}.adminDashboard`,
    defaultMessage: 'Admin Dashboard',
  },
  adminUsers: {
    id: `${scope}.adminUsers`,
    defaultMessage: 'Manage Users',
  },
  syncJobs: {
    id: `${scope}.syncJobs`,
    defaultMessage: 'Sync Jobs',
  },
  hubSpotLogs: {
    id: `${scope}.hubSpotLogs`,
    defaultMessage: 'HubSpot Logs',
  },
  bulkImport: {
    id: `${scope}.bulkImport`,
    defaultMessage: 'Bulk Import',
  },
  annualStats: {
    id: `${scope}.annualStats`,
    defaultMessage: 'Annual Statistics',
  },
  teamTags: {
    id: `${scope}.teamTags`,
    defaultMessage: 'Team Tags',
  },
  teamGroups: {
    id: `${scope}.teamGroups`,
    defaultMessage: 'Team Groups',
  },
  memberTags: {
    id: `${scope}.memberTags`,
    defaultMessage: 'Member Tags',
  },
  volunteerTags: {
    id: `${scope}.volunteerTags`,
    defaultMessage: 'Volunteer Tags',
  },
  volunteerGroups: {
    id: `${scope}.volunteerGroups`,
    defaultMessage: 'Volunteer Groups',
  },
  globalSetting: {
    id: `${scope}.globalSetting`,
    defaultMessage: 'Global Settings',
  },
  // Dynamic title messages for event groups
  activeEventGroups: {
    id: `${scope}.activeEventGroups`,
    defaultMessage: 'Active event groups',
  },
  pastEventGroups: {
    id: `${scope}.pastEventGroups`,
    defaultMessage: 'Past event groups',
  },
  allEventGroups: {
    id: `${scope}.allEventGroups`,
    defaultMessage: 'All event groups',
  },
  eventGroupHome: {
    id: `${scope}.eventGroupHome`,
    defaultMessage: 'Event Group',
  },
});
